import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

function StackedBar({ brands, height = 22 }) {
  const total = brands.reduce((sum, b) => sum + (b.value || 0), 0) || 1;
  return (
    <Box
      display="flex"
      width={{ xs: 80, sm: 120, md: 150 }} 
      height={height}
      overflow="hidden"
      boxShadow={0}
      border="1px solid #eee"
      bgcolor="#f9f9f9"
    >
      {brands.map((brand, i) => (
        <Tooltip
          key={i}
          title={
            <Box>
              <Typography variant="subtitle2" fontWeight="bold">
                {brand.name}
              </Typography>
              <Typography variant="body2">
                Market Share: {brand.value}%
              </Typography>
            </Box>
          }
          arrow
          placement="top"
        >
          <Box
            sx={{
              width: `${(brand.value / total) * 100}%`,
              bgcolor: brand.color || "#eee",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              fontSize: { xs: 10, sm: 11, md: 12 },
              fontWeight: 500,
              color: "#ffffff",
              position: "relative",
              minWidth: brand.value > 0 ? 24 : 0,
              cursor: "pointer",
              "&:hover": {
                opacity: 0.8,
              },
            }}
          >
            {brand.value > 0 && (
              <span
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  fontWeight: 500,
                  fontSize: "inherit",
                  color: "#ffffff",
                  whiteSpace: "nowrap",
                }}
              >
                {brand.value}%
              </span>
            )}
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
}

export default StackedBar;
